import styled from "styled-components"

export const FavoriteInternWrapp = styled.section`
  background: #fbfaf7;

  .favorite-intern {
    padding: 56px 0;

    .title {
      font-size: 2.4rem;
      text-align: center;
      margin-bottom: 6px;
      color: #17201b;
      letter-spacing: 0;
    }

    .subtitle {
      text-align: center;
      color: #69716b;
      font-size: 14px;
      margin-bottom: 28px;
    }

    .error-message {
      color: #7b4238;
      font-size: 14px;
      text-align: center;
      width: 100%;
    }

    .spin-load {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .favintern-card-container {
      display: flex;
      justify-content: center;
      gap: 14px;

      @media (max-width: 1050px) {
        flex-direction: column;
      }
    }
  }
`
